import { User } from "./../../auth/_models/user";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";
import { HttpClient, HttpParams } from "@angular/common/http";
import { environment } from "environments/environment";

@Injectable()
export class UserService {
  private path = environment.url + "api/usuario";

  constructor(private http: HttpClient) {}

  save(user: User): Observable<any> {
    return this.http.post(this.path, user);
  }

  sessao(): Observable<any> {
    return this.http.get(this.path + "sessao");
  }

  findUsers(params: string): Observable<User[]> {
    return this.http.get<User[]>(`${this.path}${params ? "?" + params : ""}`);
  }

  findUserService(id: string): Observable<User[]> {
    return this.http.get<User[]>(`${this.path}/${id}`);
  }

  createUsersService(user: User[]): Observable<User[]> {
    return this.http.post<User[]>(`${this.path}`, user);
  }
  editUsersService(user: User, id: string): Observable<User[]> {
    return this.http.put<User[]>(`${this.path}/${id}`, user);
  }
  changeStatusUser(id: string): Observable<any> {

    return this.http.patch<any>(`${this.path}/${id}`, null);
  }
}
